'use strict'

module.exports = require('./js')



//////////////////
// WEBPACK FOOTER
// ./~/iframe-resizer/index.js
// module id = 2521
// module chunks = 4